import { render, staticRenderFns } from "./MagnitoContent.vue?vue&type=template&id=29aa3904&"
import script from "./MagnitoContent.vue?vue&type=script&lang=js&"
export * from "./MagnitoContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports